import { render } from "./OurStoresBox.vue?vue&type=template&id=5d8e1134"
import script from "./OurStoresBox.vue?vue&type=script&lang=js"
export * from "./OurStoresBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__